// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"c158c572","207":"c29fab3d","213":"6b31146f","239":"99ddee8b","453":"ae9c510e","887":"3ebbdba5"}[chunkId] + ".chunk.js";
};